<template>
  <element>
    <AppBar :title="$t('registrationPage.title')" />
    <v-container>
      <router-link to="/newregistration">
        <v-btn color="#033e8c" height="45px" block dark>{{ $t('registrationPage.button') }}</v-btn>
      </router-link>
      <CarStatusCard
        v-for="car in cars"
        v-bind:key="car.id"
        v-bind:type="car.type"
        v-bind:vin="car.vin"
        v-bind:regDate="car.reg_date"
        v-bind:status="car.status"
      >
      </CarStatusCard>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import CarStatusCard from "@/components/registration/CarStatusCard.vue";

export default {
  name: "RegistrationPage",
  components: {
    AppBar,
    CarStatusCard,
  },
  props: {},
  data () {
    return {
      cars: [],
      errors: []
    }
  },
  mounted() {
    this.axios
      .get("/Cars/get?status=0", {}, { withCredentials: true })
      .then((response) => {
        if (response.data.status == "success") {
          console.log(response.data.data)
          this.cars = response.data.data;
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => (this.isLoading = false));
  }
}
</script>

<style scoped>

</style>